import { createFileRoute, redirect } from "@tanstack/react-router";
import { WhitelabelSettingsPage } from "@/app/partner/pages/settings/whitelabel-settings";
import { canAccessRoute } from "@/lib/auth";

export const Route = createFileRoute("/flex/dashboard/settings")({
	beforeLoad: async ({ context }) => {
		const { partner } = context;
		const access = canAccessRoute(partner, "settings");

		if (!access.allowed) {
			throw redirect({ to: "/flex/dashboard" });
		}
	},
	component: WhitelabelSettingsPage,
});
